export default __webpack_public_path__ + "static/media/noData.479dbb24.svg";